import { render, staticRenderFns } from "./MarketingEmailHeader.vue?vue&type=template&id=f4464e00&scoped=true"
import script from "./MarketingEmailHeader.vue?vue&type=script&lang=js"
export * from "./MarketingEmailHeader.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailHeader.vue?vue&type=style&index=0&id=f4464e00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4464e00",
  null
  
)

export default component.exports